var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.73529 0H32.2647C36.8118 0 40.5 3.6575 40.5 8.16667V25.6667C40.5 30.1758 36.8118 33.8333 32.2647 33.8333H21.3176L15.1471 41.2825C13.9765 42.6942 11.6647 41.8775 11.6647 40.0458V33.8333H8.73529C4.18824 33.8333 0.5 30.1758 0.5 25.6667V8.16667C0.5 3.6575 4.18824 0 8.73529 0ZM23.2133 8.74989C23.2133 7.78156 22.4251 6.99989 21.4486 6.99989H20.2721C19.2957 6.99989 18.5074 7.78156 18.5074 8.74989V9.91656C18.5074 10.8849 19.2957 11.6666 20.2721 11.6666H21.4486C22.4251 11.6666 23.2133 10.8849 23.2133 9.91656V8.74989ZM23.3604 15.5866C23.278 14.6824 22.5133 13.9941 21.6015 13.9941H20.1192C19.2074 13.9941 18.4427 14.6824 18.3604 15.5866L17.5074 24.9199C17.4133 25.9466 18.2251 26.8274 19.2663 26.8274H22.4604C23.4957 26.8274 24.3133 25.9466 24.2192 24.9199L23.3663 15.5866H23.3604Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.0fb424d348741896de889efac1a8598c.svg";
export { ForwardRef as ReactComponent };